import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { StyledBoxDayMonth } from './style';
import DayNumber from './DayNumber';
import Month from './Month';
import DayText from './DayText';

const DayMonth = ({ date, className, children, dayNumber, month, dayText }) => (
  <StyledBoxDayMonth
    className={className}
    dateTime={format(date, 'YYYY-MM-DD hh:mm')}
  >
    {dayNumber && <DayNumber date={date} />}
    {month && <Month date={date} />}
    {dayText && <DayText date={date} />}
    {children}
  </StyledBoxDayMonth>
);

DayMonth.propTypes = {
  date: PropTypes.string,
  className: PropTypes.string,
  dayNumber: PropTypes.bool,
  month: PropTypes.bool,
  dayText: PropTypes.bool
};

export default DayMonth;
